import { getStrapiBaseUrl, getWithLocaleFallback } from "../../services/strapiApi";

// Fonction pour rÃ©cupÃ©rer les donnÃ©es de la page Partenaires
export const getPartnersPageData = async () => {
  return getWithLocaleFallback(
    "/partners-page?populate[heroComponent][populate][0]=image&populate[stats]=*&populate[categories]=*&populate[partners][populate][0]=logo&populate[partners][populate][1]=category&populate[partners][populate][2]=services&populate[partners][populate][3]=certifications&populate[ctaSection]=*"
  );
};

// Fonction pour formater les donnÃ©es de la page Partenaires
export const formatPartnersPageData = (strapiData) => {
  if (!strapiData) {
    return {
      id: null,
      title: "",
      metaDescription: "",
      heroComponent: {
        title: "",
        description: "",
        image: "",
      },
      stats: [],
      categories: [],
      partners: [],
      ctaSection: {
        title: "",
        description: "",
      },
    };
  }

  // Handle both cases: strapiData with attributes or strapiData as attributes directly
  const attributes = strapiData.attributes || strapiData;

  // Extract image URL with multiple fallback strategies
  let heroImageUrl = "";
  if (attributes.heroComponent?.image?.data?.attributes?.url) {
    const imageUrl = attributes.heroComponent.image.data.attributes.url;
    heroImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${getStrapiBaseUrl()}${imageUrl}`;
  } else if (attributes.heroComponent?.image?.data?.url) {
    const imageUrl = attributes.heroComponent.image.data.url;
    heroImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${getStrapiBaseUrl()}${imageUrl}`;
  } else if (attributes.heroComponent?.image?.url) {
    const imageUrl = attributes.heroComponent.image.url;
    heroImageUrl = imageUrl.startsWith("http")
      ? imageUrl
      : `${getStrapiBaseUrl()}${imageUrl}`;
  }

  // Format stats
  const stats =
    attributes.stats?.map((stat) => ({
      id: stat?.id,
      value: stat?.value || "",
      label: stat?.title || "", // Using title as label to match the API response structure
      icon: stat?.icon || "", // Placeholder for icon if needed
    })) || [];

  // Format categories
  const categories =
    attributes.categories?.map((category) => ({
      id: category?.id,
      name: category?.name || "",
      color: category?.color || "gray",
      count: category?.count || 0, // Placeholder count - may need to calculate from partners
    })) || [];

  // Format partners
  const partners =
    attributes.partners?.map((partner) => ({
      id: partner?.id,
      name: partner?.name || "",
      description: partner?.description || "",
      location: partner?.location || "",
      employees: partner?.employees || "",
      url: partner?.url || "",
      logo: partner?.logo?.data?.attributes?.url
        ? `${getStrapiBaseUrl()}${partner.logo.data.attributes.url}`
        : partner?.logo?.url
        ? `${getStrapiBaseUrl()}${partner.logo.url}`
        : "",
      category: {
        id: partner?.category?.id,
        name: partner?.category?.name || "",
        color: partner?.category?.color || "gray",
      },
      services:
        partner?.services?.map((service) => ({
          id: service?.id,
          name: service?.name || "",
        })) || [],
      certifications:
        partner?.certifications?.map((cert) => ({
          id: cert?.id,
          name: cert?.name || "",
        })) || [],
    })) || [];

  // Format CTA section
  const ctaSection = {
    id: attributes.ctaSection?.id,
    title: attributes.ctaSection?.title || "",
    description: attributes.ctaSection?.description || "",
  };

  return {
    id: strapiData.id,
    title: attributes.title || "",
    metaDescription: attributes.metaDescription || "",
    heroComponent: {
      title: attributes.heroComponent?.title || "",
      description: attributes.heroComponent?.description || "",
      image: heroImageUrl,
    },
    stats,
    categories,
    partners,
    ctaSection,
  };
};
